import { useEffect, useState } from 'react';

const DEFAULT_STATE = {
  status: 'idle',
  endpoint: null,
  durationMs: null,
  httpStatus: null,
  error: null,
  startedAt: null,
  finishedAt: null,
  response: null,
};

export default function useApiDebug() {
  const [apiState, setApiState] = useState(DEFAULT_STATE);

  useEffect(() => {
    const handler = (event) => {
      const detail = event.detail || {};
      setApiState({
        status: detail.status || 'unknown',
        endpoint: detail.endpoint || null,
        durationMs: detail.durationMs ?? null,
        httpStatus: detail.httpStatus ?? null,
        error: detail.error || null,
        startedAt: detail.startedAt ?? null,
        finishedAt: detail.startedAt && detail.durationMs
          ? detail.startedAt + detail.durationMs
          : null,
        response: detail.response ?? null,
      });
    };

    document.addEventListener('api:room:create:completed', handler);

    return () => {
      document.removeEventListener('api:room:create:completed', handler);
    };
  }, []);

  const reset = () => setApiState(DEFAULT_STATE);

  return { apiState, reset };
}

